import './expander.scss';

document.addEventListener('DOMContentLoaded', function () {
	const elements = document.querySelectorAll(".expander_item");
	elements.forEach((elem) => {
		const title = elem.querySelector(".expander_title");
		title.addEventListener("click", () => {
			accordion_toggle(elem, elements);
		})
	})
});
